angular.module('public').controller('ForgotPasswordCtrl', ["$scope", "vcRecaptchaService", function($scope, vcRecaptchaService) {
  var getRecaptchaToken, ref;
  $scope.recaptchaKey = (ref = window.DATA) != null ? ref.recaptchaKey : void 0;
  $scope.onRecaptchaSubmitted = function(response) {
    $scope.recaptchaToken = response;
    return document.getElementById('submit-button').click();
  };
  $scope.onRecaptchaCreated = function(id) {
    return $scope.recaptchaWidgetId = id;
  };
  getRecaptchaToken = function() {
    if ($scope.recaptchaLoading) {
      return;
    }
    $scope.recaptchaLoading = true;
    return vcRecaptchaService.execute($scope.recaptchaWidgetId);
  };
  return $scope.onFormSubmit = function(event) {
    if ($scope.recaptchaKey && !$scope.recaptchaToken) {
      getRecaptchaToken();
      return event.preventDefault();
    }
  };
}]);
